import { BlogSection } from '@/types/blog';

export const machtstrukturenSection: BlogSection = {
  id: 'machtstrukturen',
  title: 'Digitale Machtstrukturen: Plattformen als neuronale Architekten',
  content: `
    <p>
      Plattformen kontrollieren heute die öffentliche Meinung. Was wir sehen, wird algorithmisch gefiltert. Wir erleben eine neue Form der Kolonialisierung – nicht geografisch, sondern neuronal. Dagegen helfen nur bewusste Bildung, kritisches Denken und emotionale Resilienz. Nur so entsteht echte digitale Mündigkeit.
    </p>
  `
};
